interface HintProps {
    keys: string[];
    label: string;
}

export function Hint({ keys, label }: HintProps) {
    return (
        <span className="inline-flex items-center gap-1.5">
            <span className="inline-flex items-center gap-0.5">
                {keys.map((k) => (
                    <kbd
                        key={k}
                        className="inline-flex h-[18px] min-w-[20px] items-center justify-center rounded border border-border bg-muted px-1 font-mono text-[10px] leading-none"
                    >
                        {k}
                    </kbd>
                ))}
            </span>
            <span>{label}</span>
        </span>
    );
}
